const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
    params: string,
    model: string,
    consorcio: boolean,
    financing: boolean,
    about: boolean,
    support: boolean,
    parts: boolean,
    team: string,
    locationId: number,
    categoryId: number
) => {
    event.preventDefault()

    const name = (event.currentTarget.elements.namedItem("fullName") as HTMLInputElement).value
    const email = (event.currentTarget.elements.namedItem("email") as HTMLInputElement).value
    const cellPhone = (event.currentTarget.elements.namedItem("phone") as HTMLInputElement).value

    try {
        const response = await fetch('/api/submitForm', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                params,
                model,
                consorcio,
                financing,
                about,
                support,
                parts,
                team,
                locationId,
                name,
                email,
                cellPhone,
                categoryId
            }),
        })

        if (!response.ok) {
            throw new Error('Erro ao enviar os dados para a API.')
        }

        window.location.href = '/form-enviado'
    } catch (error) {
        if (error instanceof Error) {
            console.error('Erro:', error.message)
        } else {
            console.error('Um erro desconhecido ocorreu:', error)
        }
    }
}

export default handleSubmit
